import { render, staticRenderFns } from "./DataSourceList.vue?vue&type=template&id=17a0d383"
import script from "./DataSourceList.vue?vue&type=script&lang=js"
export * from "./DataSourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports